module.exports = __webpack_public_path__ + "static/img/编组 5备份 3.44988fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hz/编组 5备份 3.png
// module id = uZs3
// module chunks = 1